export { default, PERMISSION_TYPES } from './isPermitted';
